@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.link {
    composes: link from "../LocatorMap/GetDirectionsLink.module.scss";
    font-size: 1.215rem;
    justify-content: flex-start;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        justify-content: center;
    }
}
